import { Component } from '@angular/core';
import { Router} from '@angular/router'; 
import { MenuController } from '@ionic/angular';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(public router: Router,
              private menu: MenuController) {}       
  
  logout(){
    localStorage.setItem('login','0');
    this.router.navigateByUrl('/login'); 
    this.menu.close()
  }

  attivita(){
    this.router.navigateByUrl('/attivita'); 
    this.menu.close()
  }

  progetti(){
    this.router.navigateByUrl('/progetti'); 
    this.menu.close()
  }

  main(){
    this.router.navigateByUrl('/main'); 
    this.menu.close()
  }

  statistiche(){
    this.router.navigateByUrl('/statistiche'); 
    this.menu.close()
  }

  clienti(){
    this.router.navigateByUrl('/clienti'); 
    this.menu.close()
  }  

  rapportino(){
    this.router.navigateByUrl('/rapportino'); 
    this.menu.close()
  } 

}
